module.exports = __webpack_public_path__ + "img/blog-16-2.e200caf7.webp";